import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from '@mui/material';

export interface BatchError {
  recordId: string;
  field: string;
  message: string;
  value: string;
}

export interface SubmissionReport {
  successCount: number;
  failedCount: number;
  errors: (string | BatchError)[];
}

interface SubmissionReportDialogProps {
  open: boolean;
  onClose: () => void;
  report: SubmissionReport | null;
  onErrorClick?: (recordId: string) => void;
}

const SubmissionReportDialog: React.FC<SubmissionReportDialogProps> = ({
  open,
  onClose,
  report,
  onErrorClick
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>
        <Typography variant="h6" component="div">
          Submission Report
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle1" color="success.main">
            Successfully processed: {report?.successCount} records
          </Typography>
          <Typography variant="subtitle1" color="error.main">
            Failed: {report?.failedCount} records
          </Typography>
        </Box>

        {report?.errors && report.errors.length > 0 && (
          <Box>
            <Typography variant="subtitle1" sx={{ mb: 1 }}>
              Error Details:
            </Typography>
            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Record</TableCell>
                    <TableCell>Error</TableCell>
                    <TableCell width="130px"></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {report.errors.map((error, index) => {
                    if (typeof error === 'string') {
                      return (
                        <TableRow key={index}>
                          <TableCell colSpan={4}>
                            <Typography fontSize={12} color="error">{error}</Typography>
                          </TableCell>
                        </TableRow>
                      );
                    }
                    return (
                      <TableRow 
                        key={index}
                        // onClick={() => onErrorClick?.(error.recordId)}
                        sx={{ 
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                          }
                        }}
                      >
                        <TableCell sx={{ fontSize: 12 }}>{error.recordId}</TableCell>
                        {/* <TableCell sx={{ fontSize: 12 }}>{error.field}</TableCell> */}
                        <TableCell sx={{ fontSize: 12 }}>
                          <Typography fontSize={12} color="error">{error.message}</Typography>
                        </TableCell>
                        <TableCell onClick={() => onErrorClick?.(error.recordId)} sx={{ fontSize: 12 }}>⇒ Jump to record</TableCell> 
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubmissionReportDialog; 